var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPnc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 30,
    height: 30,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M20.8 15.9h-2.9c.1-.4.1-.8-.2-1.3L13 6.4c-.7-1.2-1.4-2.1-2-2.8 1.9 1 5.6 3.1 12.8 7.3l.4.2c1.3.8 2.1 2 1.9 2.8-.3 1.3-2.2 2-5.3 2m-9.4 8-.4.3c-1.3.8-2.8.8-3.4.2-.8-.8-.4-2.8 1.1-5.5l1.4-2.5c.3.3.7.5 1.2.5h9.4c1.4 0 2.5-.1 3.5-.4-1.8 1.2-5.5 3.3-12.8 7.4m-5-17.2v-.5c0-1.5.6-2.8 1.5-3 1.1-.3 2.7 1.1 4.2 3.7l1.4 2.5c-.4.1-.8.4-1 .8l-4.7 8.1c-.7 1.2-1.2 2.2-1.4 3.2V6.7M13.9 0C6.2 0 0 6.2 0 13.9s6.2 13.9 13.9 13.9 13.9-6.2 13.9-13.9S21.6 0 13.9 0",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#001744",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPnc);
export default __webpack_public_path__ + "static/media/pnc.57bc16b13c692d041edf8db005128ccb.svg";
export { ForwardRef as ReactComponent };